import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Icon as KIcon, } from '@ui-kitten/components';
import styled from "../../../theming/util/styled";
import util from "../../util";
const S = StyleSheet.create({
    zeroPadding: {
        padding: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingVertical: 0,
        paddingHorizontal: 0,
    },
    zeroMargin: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginVertical: 0,
        marginHorizontal: 0,
    },
});
const DNAIcon = ({ testID, ...props }) => (<View testID={testID}>
    <KIcon {...props}/>
  </View>);
function parseThemeStyle(source) {
    const { iconWidth, iconHeight, textColor, iconMarginHorizontal, ...buttonContainer } = source;
    return {
        buttonContainer,
        icon: {
            width: iconWidth,
            height: iconHeight,
            color: textColor,
            textColor,
            marginHorizontal: iconMarginHorizontal,
        },
    };
}
const DNAIconStyled = (props) => {
    const { eva, color, CustomIcon, width, height, viewBox, testID, name, ...rest } = props;
    const { icon } = parseThemeStyle(eva?.style);
    const finalStyle = util.mergeStyles(props, icon, [{ width }, width], [{ height }, height], S.zeroPadding, S.zeroMargin);
    if (CustomIcon) {
        return (<CustomIcon data-testid={testID} // testID is a valid RN prop, but RNWeb may not yet convert it to be DOM friendly
         width={width} height={height} color={color || StyleSheet.flatten(finalStyle)?.tintColor}/>);
    }
    return (<View testID={`icon-${name}${testID ? `-${testID}` : ''}`}>
      <KIcon {...rest} name={name} style={finalStyle}/>
    </View>);
};
DNAIcon.displayName = 'DNAIcon';
DNAIconStyled.displayName = 'DNAIconStyled';
DNAIcon.Styled = styled('Button')(DNAIconStyled);
export default DNAIcon;
//# sourceMappingURL=DNAIcon.js.map